const country: any = {
    'AU': 'AUD',
    'NZ': 'NZD',
    'UK': 'GBP',
    'GB': 'GBP',
};

const v = {
    country
};

export default v;
